import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import NewsletterPromoImage from "cards/components/NewsletterPromoImage";

import styles from "./NewsletterPromo.css";

export default function NewsletterPromo({
  title,
  content,
  link,
  subscribeLink,
  image,
}) {
  return (
    <div className={styles.root}>
      <NewsletterPromoImage src={image} />
      <div className={styles.card}>
        <h4>
          <Link
            to={link}
            className={classNames(styles.header, "gtm-nl-promo-title")}
          >
            {title}
          </Link>
        </h4>
        <p className={styles.paragraph}>{content}</p>
        <a
          href={subscribeLink}
          className={classNames(styles.subscribe, "gtm-nl-promo-cta")}
        >
          Subscribe
        </a>
      </div>
    </div>
  );
}

NewsletterPromo.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};
